import Login from '../../../scenes/common/Login';
import { RequestNewPassword } from '../../../scenes/common/RequestNewPassword/RequestNewPassword';
import { ResetPassword } from '../../../scenes/common/ResetPassword/ResetPassword';

import AccountSettings from '../../../scenes/player/AccountSettings';
import EditPicture from '../../../scenes/player/AccountSettings/EditPicture';
import SelectPicture from '../../../scenes/player/AccountSettings/SelectPicture';
import TakePicture from '../../../scenes/player/AccountSettings/TakePicture';
import ClubAbout from '../../../scenes/player/ClubAbout/ClubAbout';
import ClubEvents from '../../../scenes/player/ClubEvents/ClubEvents';
import ClubHome from '../../../scenes/player/ClubHome';
import ClubInfoRoot from '../../../scenes/player/ClubInfoRoot';
import ClubPages from '../../../scenes/player/ClubPages';
import ClubPay from '../../../scenes/player/ClubPay';
import ClubPolicies from '../../../scenes/player/ClubPolicies';
import ClubRoot from '../../../scenes/player/ClubRoot';
import ClubRoster from '../../../scenes/player/ClubRoster/ClubRoster';
// import { ClubStandings } from '../scenes/player/ClubStandings/ClubStandings';
import EventHome from '../../../scenes/player/EventHome';
import EventLeaderboards from '../../../scenes/player/EventLeaderboards/EventLeaderboards';
import EventPostScore from '../../../scenes/player/EventPostScore';
import EventRoot from '../../../scenes/player/EventRoot';
import EventStandings from '../../../scenes/player/EventStandings/EventStandings';
import Home from '../../../scenes/player/Home/Home';
import IndividualLeaderboards from '../../../scenes/player/IndividualLeaderboards/IndividualLeaderboards';
import Profile from '../../../scenes/player/Profile/Profile';
import SetScores from '../../../scenes/player/SetScores/SetScores';
import ConfirmScores from '../../../scenes/player/SetScores/ConfirmScores';
import { SetHoleScores } from '../../../scenes/player/SetScores/SetHoleScores/SetHoleScores';
import SetScorer from '../../../scenes/player/SetScores/SetOfficialScorer/SetOfficialScorer';
import { SelectCTPWinner } from '../../../scenes/player/SetScores/SelectCTPWinner/SelectCTPWinner';
import HoleSectionBifurcation from '../../../scenes/player/SetScores/HoleSectionBifurcation/HoleSectionBifurcation';
import SetCTPWinner from '../../../scenes/player/SetScores/SetCTPWinner/SetCTPWinner';
import SetMoneyBallOrder from '../../../scenes/player/SetScores/SetMoneyBallOrder/SetMoneyBallOrder';

import { IRoute } from '../IRoute';

const PlayerRoutes: IRoute[] = [
  {
    actions: ['events', 'user'],
    component: Profile,
    key: '/profile',
    path: '/profile'
  },
  {
    actions: ['clubs', 'events', 'user', 'profile'],
    component: Profile,
    key: '/profile/:playerId/club/:clubId',
    path: '/profile/:playerId/club/:clubId'
  },
  {
    actions: ['events', 'clubs', 'games', 'user'],
    component: Home,
    key: '/home',
    path: '/home',
    scope: 'user'
  },
  {
    actions: ['clubs', 'events', 'user', 'profile'],
    children: [
      {
        actions: ['clubs', 'events', 'games', 'user'],
        component: ClubHome,
        key: 'club-home',
        path: '/'
      },
      {
        actions: ['clubs', 'events', 'seasons'],
        component: ClubEvents,
        key: 'club-events',
        path: 'events'
      },
      {
        actions: ['clubs', 'events', 'seasons'],
        component: ClubEvents,
        key: 'club-events',
        path: 'events/:seasonId'
      },
      {
        actions: ['clubs', 'events', 'pages'],
        component: ClubInfoRoot,
        key: 'club-info',
        path: 'club-info'
      },
      {
        actions: ['clubs', 'events', 'user', 'profile'],
        component: Profile,
        key: '/profile/:playerId',
        path: '/profile/:playerId'
      },
      {
        actions: ['clubs'],
        component: ClubRoster,
        key: 'club-roster',
        path: 'players'
      }
      // Disabled due to https://code.talpor.com/club15/frontend/-/issues/888
      // {
      //   actions: ['clubs', 'seasons', 'seasonAwards'],
      //   component: ClubStandings,
      //   key: 'club-standings',
      //   path: 'standings'
      // },
      // {
      //   actions: ['clubs', 'seasons', 'seasonAwards'],
      //   component: ClubStandings,
      //   key: 'club-standings',
      //   path: 'standings/:seasonId'
      // }
    ],
    component: ClubRoot,
    key: '/club/:clubId',
    path: '/club/:clubId'
  },
  {
    actions: ['clubs'],
    component: ClubAbout,
    key: '/club/:clubId/about',
    path: '/club/:clubId/about'
  },
  {
    actions: ['clubs'],
    component: ClubPolicies,
    key: '/club/:clubId/policies',
    path: '/club/:clubId/policies'
  },
  {
    actions: ['clubs', 'events', 'user'],
    children: [
      {
        actions: ['clubs', 'events', 'user', 'notifications'],
        component: EventHome,
        key: 'event-home',
        path: '/'
      },
      {
        actions: ['events'],
        component: EventStandings,
        key: 'event-standings',
        path: 'field'
      },
      {
        actions: ['clubs', 'user', 'events', 'roundScores', 'roundResults', 'games', 'scores'],
        component: EventLeaderboards,
        key: '/leaderboard',
        path: '/leaderboard'
      }
    ],
    component: EventRoot,
    key: 'event/:eventId',
    path: 'event/:eventId'
  },
  {
    actions: ['events', 'games'],
    component: EventPostScore,
    key: 'event/:eventId/game/:gameId/post-score',
    path: 'event/:eventId/game/:gameId/post-score'
  },
  {
    actions: ['events', 'rounds', 'games'],
    children: [
      {
        actions: ['events', 'rounds', 'games'],
        component: SetScorer,
        key: 'set-scorer',
        path: 'set-scorer'
      },
      {
        actions: ['events', 'rounds', 'games'],
        component: SetMoneyBallOrder,
        key: 'set-moneyball-order',
        path: 'set-moneyball-order'
      },
      {
        actions: ['events', 'rounds', 'games', 'scores'],
        component: SetHoleScores,
        key: 'set-hole',
        path: 'hole/:holeIndex/editor'
      },
      {
        component: SelectCTPWinner,
        key: 'ctp-editor',
        path: 'hole/:holeIndex/selectctpwinner'
      },
      {
        component: SetCTPWinner,
        key: 'ctp-editor',
        path: 'hole/:holeIndex/setctpwinner/:enrollmentId'
      },
      {
        actions: ['events', 'rounds', 'games', 'scores'],
        component: HoleSectionBifurcation,
        key: 'set-hole-leaderboard',
        path: 'hole/:holeIndex'
      },
      {
        actions: ['events', 'rounds', 'games', 'scores'],
        component: ConfirmScores,
        key: 'complete',
        path: 'complete'
      }
    ],
    component: SetScores,
    key: 'event-scores/:eventId/round/:roundId',
    path: 'event-scores/:eventId/round/:roundId'
  },
  {
    actions: ['clubs', 'errors', 'invitation', 'memberships', 'user'],
    component: ClubPay,
    key: '/club-payment/:clubId',
    path: '/club-payment/:clubId'
  },
  {
    actions: ['clubs'],
    component: ClubPages,
    key: '/club/:clubId/pages/:slug',
    path: '/club/:clubId/pages/:slug',
    scope: 'staff'
  },
  {
    actions: ['clubs', 'standings', 'user'],
    component: IndividualLeaderboards,
    key: '/club/:clubId/individual-leaderboards',
    path: '/club/:clubId/individual-leaderboards'
  },
  {
    actions: ['clubs', 'user', 'memberships'],
    component: AccountSettings,
    key: '/profile/settings',
    path: '/profile/settings'
  },
  {
    actions: ['avatar', 'user'],
    component: EditPicture,
    key: '/profile/edit-picture',
    path: '/profile/edit-picture'
  },
  {
    actions: ['avatar', 'user'],
    component: SelectPicture,
    key: '/profile/select-picture',
    path: '/profile/select-picture'
  },
  {
    actions: ['avatar', 'user'],
    component: TakePicture,
    key: '/profile/take-picture',
    path: '/profile/take-picture'
  },
  {
    actions: ['invitation'],
    component: Login,
    key: '/login',
    path: '/login',
    scope: 'guest'
  },
  {
    actions: ['invitation'],
    component: Login,
    key: '/login/:invitationId',
    path: '/login/:invitationId',
    scope: 'guest'
  },
  {
    actions: ['invitation'],
    component: RequestNewPassword,
    key: '/requestResetPassword',
    path: '/requestResetPassword',
    scope: 'guest'
  },
  {
    actions: ['invitation'],
    component: ResetPassword,
    key: '/password/reset/:uid/:token',
    path: '/password/reset/:uid/:token',
    scope: 'guest'
  }
];
export default PlayerRoutes;
